import { render, staticRenderFns } from "./Centros.vue?vue&type=template&id=7af9036f"
import script from "./Centros.vue?vue&type=script&lang=js"
export * from "./Centros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports